import React from "react";
import { Form } from "antd";
import { noop } from "lodash";
import styled from "styled-components";

import { DATE_DATA_FORMAT, DATE_FORMAT } from "../../../../utils/date";
import { dateParser } from "../utils";
import { DatePicker } from "@tailormed/common-client/component/DatePicker";

// Opt-in via `dedicatedFieldProps.floatError` (e.g. GSK's dynamic patientMinAgeRule):
// some rules' error message causes a layout shift (the row jumps when the error
// appears/disappears). Absolutely positioning the explain div makes it float below
// the picker without displacing adjacent rows. Off by default so every other date
// field keeps its normal (layout-affecting) error placement.
const DateFormItemStyled = styled(Form.Item)`
  position: relative;
  .ant-form-item-explain {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
  }
`;

export default ({
  onChange = noop,
  required = false,
  placeholder = DATE_FORMAT,
  defaultDate = null,
  disabledDate = null,
  disabled,
  rules = [],
  floatError = false,
  ...props
}) => {
  const FormItemComponent = floatError ? DateFormItemStyled : Form.Item;
  return (
    <FormItemComponent
      rules={[{ type: "date" }, { required }, ...rules]}
      getValueProps={dateParser}
      getValueFromEvent={(momentValue) => momentValue?.format(DATE_DATA_FORMAT)}
      {...props}
    >
      <DatePicker
        onChange={onChange}
        placeholder={placeholder}
        defaultPickerValue={defaultDate}
        disabledDate={disabledDate}
        disabled={disabled}
      />
    </FormItemComponent>
  );
};
